import styled from 'styled-components';
import checkIcon from '../../../icons/checkClaytonBlue.svg';

export default styled.div`
  h3 {
    margin: 0 0 1.375rem 0;

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      margin: 0 0 1.1875rem 0;
    }
  }

  ul {
    margin: 0;
    max-width: ${props => props.theme.maxWidths.ctaModalImage};
    padding: 0;
  }

  li {
    font-size: ${props => props.theme.type.paragraph.default};
    letter-spacing: ${props => props.theme.letterSpacing.paragraph};
    line-height: ${props => props.theme.lineHeights.paragraph.default};
    padding: 0.28125rem 0 0.28125rem 2.5rem;
    list-style: none;
    position: relative;

    &::before {
      content: '';
      display: block;
      width: 1.25rem;
      height: 1.25rem;
      position: absolute;
      top: 9px;
      left: 0;
      background: url(${checkIcon});
      background-size: 100% 100%;
    }
  }
`;
